import JobsFeed from './JobsFeed'

export default JobsFeed
